<template>
	<div class="dialog draggable-item bg-light light center text-small overflow w-100-sm w-100-md w-75-lg w-50-xl h-50" v-cloak>

		<DialogTitle :title="$t('Download items')" defaultTitle="" @closeDialog="$root.$emit('CLOSEDOWNLOADITEMSDIALOG')" />

		<!--FINE DIALOG TITLE-->

		<div class="dialog-content overflow bg-light">

			<!--SELECT SERVICE TYPE-->
			<div v-once class="form-group">
				<label class="text-bold">{{ $t("Select a service type") }}</label>
				<select class="select text-small w-auto px-2" v-model="sourceType" @change="onChangeSourceType()">
					<option :value="-1"></option>
					<optgroup v-for="(types, category) in sourceTypesMap" :label="$t(category)" v-once>
						<option v-for="type in types" :key="type" :value="type"> {{ $ONEServiceTypeInfo['' + type].name }}</option>
					</optgroup>
				</select>
			</div>

			<!--SELECT SERVICE ACCOUNT-->
			<!--Questa pagina deve implementare il metodo "sendSATestResult"-->
			<SARepoSelect v-if="showAll" class="form-group p-3" :type="sourceType" idSA="" idRepo="" @sendSATestResult="sendSATestResult" ref="saRepoSelect" />

			<!--SELECT ITEMS-->
			<SelectedResourcesLayout v-if="showAll" buttonText="Select files and folders" :singleItem="false" :type="sourceType" :isDisabled="!testResult.ok" :list="sourceSelectedNodes" :heightPercentage="30" :canCancel="true" @clickFunction="toggleFileSystemSidebar(true)" />

			<!--SELECT DESTINATION PATH-->
			<SelectedResourcesLayout buttonText="Select destination path" :singleItem="true" :type="$ONEServiceType.FileFolder" :list="destinationSelectedNodes" :heightPercentage="30" :canCancel="true" @clickFunction="toggleFileSystemSidebar(false)" />
		</div>
		<div class="dialog-actions">
			<ClientMessageView :commands="['downloaditems']" :clampLines="4" ref="CM_DWNL" />
			<div v-if="wait"><span class="mif-spinner2 ani-spin" /></div>
			<button v-else class="button secondary" :disabled="!enableDownloadButton" v-disable-tooltip:downloadButton_disabled_message @click="download()">{{ $t("Download") }}</button>

			<button class="button secondary" @click="$root.$emit('CLOSEDOWNLOADITEMSDIALOG')">{{ $t("Close") }}</button>

		</div>
	</div>
</template>
<script>
import DialogTitle from "../utils/DialogTitle.vue";
import SARepoSelect from "../utils/SARepoSelect.vue";
import SelectedResourcesLayout from "../utils/SelectedResourcesLayout.vue";

import { cookieManager, getMapWithCategoriesAndPlatformTypes, isValid, waitSeconds } from "../../utils/utilitiesmodule";
import { ClientMessage } from "../../utils/objects";
import { draggableMixin } from "../../mixins/draggable-mixin";
import ClientMessageView from "./view/ClientMessageView.vue";
import { ClientTreeNode, FileSystemSidebarConfig } from "../../models/TreeNode";
import { getSARootPath, testServiceAccount } from "../../utils/entityMethods/serviceAccount";



export default {

	mixins: [draggableMixin],
	name: "DownloadItems",
	components: {
		SARepoSelect,
		SelectedResourcesLayout,
		"DialogTitle": DialogTitle,
		ClientMessageView
	},

	props: {
		serviceAccount: Object,
	},

	data() {
		return {
			sourceType: -1,
			sourceTypesMap: getMapWithCategoriesAndPlatformTypes("forDownloadItems", true),
			testResult: {
				ok: false,
				okNumber: 0,
				serviceAccount: null,
				client: null,// il client della piattaforma che effettuerà le richieste dei list
				list: null,
			},
			sourceSelectedNodes: [],
			root: null,
			downloadButton_disabled_message: "",
			destinationSelectedNodes: [
				new ClientTreeNode("", "", cookieManager.getCookie("downloadFolderPath"), this.$FileFolderEntityType.FN_Folder)
			],
			wait: false,
			showAll: false,
			itemsDownloaded: false

		}
	},
	computed: {
		enableDownloadButton() {

			if (this.sourceType == -1) {
				this.downloadButton_disabled_message = this.$t("Select a service type");
				this.setClientMessage(ClientMessage.info("Select a service type", null, "downloaditems"));
				return false;
			}

			if (!this.testResult.ok) {
				this.downloadButton_disabled_message = this.$t('Select and test a service account.');
				this.setClientMessage(ClientMessage.info("Select and test a service account.", null, "downloaditems"));
				return false;
			}


			if (this.sourceSelectedNodes.length == 0) {
				this.downloadButton_disabled_message = this.$t("Select items to download");
				this.setClientMessage(ClientMessage.info("Select items to download", null, "downloaditems"));
				return false;
			}

			if (this.destinationSelectedNodes.length == 0) {
				this.downloadButton_disabled_message = this.$t("Select destination path");
				this.setClientMessage(ClientMessage.info("Select destination path", null, "downloaditems"));
				return false;
			}

			if (this.itemsDownloaded) {
				this.downloadButton_disabled_message = this.$t("Already downloaded items");
				return false;
			}

			this.downloadButton_disabled_message = "";
			this.setClientMessage(null);
			return true;
		},
	},
	methods: {
		getSARootPath,
		testServiceAccount,

		onChangeSourceType() {
			this.showAll = false;
			this.sourceSelectedNodes.clear();
			this.destinationSelectedNodes.clear();
			const downloadFolderPath = cookieManager.getCookie("downloadFolderPath");
			waitSeconds(0.2).then(() => {
				if (isValid(downloadFolderPath)) {
					this.destinationSelectedNodes.push(new ClientTreeNode("", "", downloadFolderPath, this.$FileFolderEntityType.FN_Folder));
				}
				this.itemsDownloaded = false;
				this.showAll = true;
			})
		},
		sendSATestResult(testResult) {
			this.testResult = testResult;
			if (!this.testResult.ok) {
				return;
			}

			this.root = this.getSARootPath(testResult.serviceAccount);
			//}
		},

		async toggleFileSystemSidebar(isForSource) {
			this.$root.$emit("closeFileSystemSidebar");
			this.itemsDownloaded = false;

			if (isForSource && this.testResult.client.serviceAccount.options.accountSessionId == "") {
				this.testResult.client.serviceAccount = (await this.testServiceAccount(this.testResult.client.serviceAccount)).serviceAccount
				if (this.testResult.client.serviceAccount == null) {
					return;
				}
			}
			var config = FileSystemSidebarConfig.get(
				isForSource ? this.sourceType : this.$ONEServiceType.FileFolder,
				isForSource,
				isForSource ? 0 : 1,
				isForSource ? this.testResult.client : null,
				isForSource ? this.root : null,
				null,
				false
			);

			this.$root.$emit(
				"toggleFileSystemSidebar",
				isForSource ? this.sourceSelectedNodes : this.destinationSelectedNodes,
				config
			);

		},

		setClientMessage(clientMessage) {
			if (this.$refs.CM_DWNL) {
				this.$refs.CM_DWNL.setClientMessage(clientMessage);

			} else {
				waitSeconds(0.2).then(() => {
					this.$refs.CM_DWNL.setClientMessage(clientMessage);
				});
			}
		},

		download() {
			this.$root.$emit("closeFileSystemSidebar");

			const obj = {
				idSA: this.testResult.serviceAccount.id,
				nodes: this.sourceSelectedNodes,
				destinationPath: this.destinationSelectedNodes[0].path
			}
			this.wait = true;
			this.$root.socket("downloaditems", obj).then(ok => {
				this.itemsDownloaded = ok;
				this.wait = false;
			});
		}
	}
}
</script>
